import { render, staticRenderFns } from "./branded-fare-card.vue?vue&type=template&id=4980e3c2&scoped=true"
import script from "./branded-fare-card.vue?vue&type=script&lang=js"
export * from "./branded-fare-card.vue?vue&type=script&lang=js"
import style0 from "./branded-fare-card.vue?vue&type=style&index=0&id=4980e3c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4980e3c2",
  null
  
)

export default component.exports